import React, { useRef, useState } from "react";
import "./ImageInput.css";
import { SecondaryButton } from "../buttonComponent/ButtonComponent";
import UploadIcon from "./img/upload.svg"

const ImageInput = ({
  onFileUpload,
  label,
  disable,
  type = "button",
  dropzoneWidth = "20rem",
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleClick = () => {
    if (disable) return;
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      validateAndConvertToBase64(file);
    }
  };

  const validateAndConvertToBase64 = (file) => {
    const validTypes = [
      "image/svg+xml",
      "image/png",
      "image/jpeg",
      "image/gif",
    ];
    if (validTypes.includes(file.type)) {
      convertToBase64(file);
    } else {
      console.error(
        "Invalid file type: Please upload only SVG, PNG, JPG, or GIF files."
      );
    }
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (onFileUpload) {
        onFileUpload(reader.result); // Send base64 data
      }
    };
    reader.onerror = (error) => {
      console.error("Error converting file to Base64:", error);
    };
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    if (disable) return;
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (disable) return;
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      validateAndConvertToBase64(file);
    }
  };

  return (
    <div className="upload-photo-container">
      {type === "button" ? (
        <>
          <SecondaryButton
            onClickFunction={handleClick}
            label={label}
            width="9.2rem"
            disable={disable}
          />
        </>
      ) : (
        <div
          className={`dropzone ${isDragging ? "dragging" : ""} ${
            disable ? "disabled" : ""
          }`}
          style={{ width: dropzoneWidth }}
          onClick={!disable ? handleClick : undefined}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <img
            src={UploadIcon}
            alt="Upload Icon"
          />
          <p className="dropzone-text-main"><strong>Click to upload</strong> or drag and drop</p>
          <p className="dropzone-text-sub">SVG, PNG, or JPG</p>
        </div>
      )}

      <input
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        accept="image/svg+xml, image/png, image/jpeg, image/gif"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default ImageInput;
